import { render, staticRenderFns } from "./CSVExport.vue?vue&type=template&id=390c1965&"
import script from "./CSVExport.vue?vue&type=script&lang=ts&"
export * from "./CSVExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports